import _extends from "@babel/runtime/helpers/esm/extends";
const getSeriesWithDefaultValues = (seriesData, seriesIndex, colors) => {
  return _extends({}, seriesData, {
    id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
    data: seriesData.data.map((d, index) => _extends({}, d, {
      color: d.color ?? colors[index % colors.length]
    }))
  });
};
export default getSeriesWithDefaultValues;